import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
  Typography,
} from '@material-ui/core';
import HelpOutlineRoundedIcon from '@material-ui/icons/HelpOutlineRounded';
import {useStyles} from './styles';

/**
 * function to render confirmation dialog
 * @param title: title of the dialog
 * @param message: message on the dialog
 * @param open: boolean to open the dialog
 * @param setOpen: function to set open state of the dialog
 * @param onConfirm: function to handle on confirm click
 * @returns {JSX.Element}
 * @constructor
 */
const ConfirmationDialog = ({title, message, open, setOpen, onConfirm}) => {
  const classes = useStyles();

  /**
   * function to close the dialog
   */
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      maxWidth='xs'
      fullWidth
      open={open}
      TransitionComponent={Slide}
      disableBackdropClick
      classes={{paper: classes.dialogPaper}}
    >
      <Box className={classes.iconWrap}>
        <HelpOutlineRoundedIcon className={classes.icon} />
      </Box>

      <Typography className={classes.title}>{title}</Typography>

      <DialogContent className={classes.content}>
        <DialogContentText component={Box} className={classes.message}>
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions classes={{root: classes.actionsContainer}}>
        <Button
          variant='outlined'
          color='primary'
          onClick={handleClose}
          className={classes.noBtn}
        >
          No
        </Button>
        <Button
          variant='contained'
          color='primary'
          disableElevation
          onClick={onConfirm}
          className={classes.yesBtn}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
